<template>
	<div>
		<template v-if="placementevents.length">
			<div v-for="placement in placementevents" :key="placement.id">
				<PlacementEventsListItem 
					:placement="placement" 
					@newMessageCallback="newMessage"
				/>
			</div>
		</template>
		<div v-else class="alert alert-info">{{$t('no-results')}}</div>
	</div>
</template>

<script>
import PlacementEventsListItem from "./PlacementEventsListItem";
export default {
	components: {
		PlacementEventsListItem
	},
    props: {
        placementevents: Array
    },
    data() {
    	return {
    	}
    },
	mounted() {
	},
	methods: {
		newMessage(recipients){
			this.$emit('newMessageCallback' , recipients);
		}
	}
};
</script>
